import { apiClient } from "model/axiosConfig";
import { typeProductsFilters } from "./dEdmProductsReducer";
import { typeRequestPagination } from "../system/constants";
import { typeAddEdmProductsItemObject } from "../../components/containers/dashboard/dataEdmProducts/popupContents/popupAdd";
import { typeEditEdmProductsItemObject } from "../../components/containers/dashboard/dataEdmProducts/popupContents/popupEdit";

export const getEdmProductList = async (payload: {
  primaryTenant: string;
  filters: typeProductsFilters;
  paginationRequest?: typeRequestPagination;
}) => {
  const path = `/store/store-product/search`;

  // TODO:: add types after backend will be ready
  const filter: any = {};

  if ("marked" in payload.filters) {
    filter.marked = payload.filters.marked;
  }

  if (payload.filters.name?.trim()) {
    filter.name = payload.filters.name.trim();
  }

  if (payload.filters.barcode?.trim()) {
    filter.barcode = payload.filters.barcode.trim();
  }

  if ("invalidPsid" in payload.filters) {
    filter.psid = payload.filters.invalidPsid === true ? "invalid" : null;
  }

  try {
    // TODO:: add another filters after backend will be ready
    return await apiClient.post(path, {
      filter: filter,
      pagination: {
        pageNumber: payload.paginationRequest?.page ?? 0,
        pageSize: payload.paginationRequest?.size || 14,
      },
    });
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getEdmProductItemById = async (itemId: string) => {
  const path = `/store/store-product/${itemId}`;

  try {
    return await apiClient.get(path);
  } catch (error) {
    return error.response;
  }
};

export const addEdmProductItem = async (
  payload: typeAddEdmProductsItemObject,
) => {
  const path = "/store/store-product";

  const config = {
    headers: {},
  };

  try {
    return await apiClient.post(path, payload, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const editEdmProductItem = async ({
  id,
  ...payload
}: typeEditEdmProductsItemObject) => {
  const path = `/store/store-product/${id}`;

  const config = {
    headers: {},
  };

  try {
    return await apiClient.patch(path, payload, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
